import { applyNavItemSortOrder } from './navItemsForm.utils'

export const TOP_MESSAGE_BAR_ENABLED_FIELD = 'pages./.blocks.header.banner.0.is_enabled'
export const TOP_MESSAGE_BAR_NAV_ITEMS_FIELD = 'pages./.blocks.header.banner.0.nav_items'

export const PAGE_ANNOUNCEMENT_LINK_OPTIONS = {
  aboutUs: { label: 'About Us', href: '/about-us' },
  gallery: { label: 'Gallery', href: '/gallery' },
  contactUs: { label: 'Contact', href: '/contact-us' },
  reviews: { label: 'Reviews', href: '/reviews' },
}

export const createTopMessageBarNavItem = ({ id, label, href, props = {}, ...rest } = {}) => ({
  id: id || Date.now(),
  label,
  href,
  props: { align: 'right', showOnMobile: false, ...props },
  ...rest,
})

export const hasTopMessageBarLink = (items, href) =>
  (Array.isArray(items) ? items : []).some((item) => item?.type === 'link' && item?.href === href)

export const addTopMessageBarPageLink = (items, option) => {
  const currentItems = Array.isArray(items) ? items : []

  if (!option?.href || hasTopMessageBarLink(currentItems, option.href)) {
    return currentItems
  }

  return applyNavItemSortOrder([
    ...currentItems,
    createTopMessageBarNavItem({
      id: `page-link:${option.href}`,
      type: 'link',
      label: option.label,
      href: option.href,
    }),
  ])
}

export const removeTopMessageBarPageLink = (items, href) =>
  applyNavItemSortOrder(
    (Array.isArray(items) ? items : []).filter(
      (item) => !(item?.type === 'link' && item?.href === href)
    )
  )
